import React, { useState, useEffect } from "react";
import "./MscsPage.css";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import technopark from "../images/technopark.jpg";
import memberImg from "../images/member.jpg";
import bankingImg from "../images/banking.jpg";
import complianceImg from "../images/compliance.jpg";
import digitalImg from "../images/mobile.jpg";
import reportImg from "../images/reporting.jpg";

function MscsPage() {
  const [widgetId, setWidgetId] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      const container = document.getElementById("recaptcha-mscs");
      if (container && container.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(container, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
             sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA MscsPage render error:", err);
        }
      }
    }
  }, []);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    organization: "",
    challenges: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.phone) {
      setMessage("❌ Name & Phone required");
      return;
    }

    setLoading(true);

    try {
      const token = getResponse(widgetId);
      if (!token) {
        setMessage("❌ Please complete the reCAPTCHA");
        setLoading(false);
        return;
      }
      const fd = new FormData();
      Object.keys(formData).forEach(k => fd.append(k, formData[k]));
      fd.append("_type", "mscs_demo");
      fd.append("tk", token);

      const response = await fetch(
        BASE_URL + "/DemoApi/saveData",
        {
          method: "POST",
          body: fd
        }
      );

      const result = await response.json();

      if (result.status) {
        setMessage("✅ Demo Request Submitted");
        setFormData({
          full_name: "",
          phone: "",
          email: "",
          organization: "",
          challenges: ""
        });
      } else {
        setMessage("❌ " + (result.message || "Verification Failed"));
      }

    } catch (err) {
      console.error("Submission Error:", err);
      setMessage("❌ Submission Failed. Check Console.");
    }

    setLoading(false);
  };

  const sections = [
    {
      title: "Member Management",
      image: memberImg,
      points: [
        "Automated Membership Lifecycle – Enrollment to exit with Digital KYC",
        "Voting Power & Share Management",
        "Dividend Distribution Automation",
        "Multi-Member & Joint Accounts",
        "Nominee Management"
      ]
    },
    {
      title: "Core Banking Operations",
      image: bankingImg,
      points: [
        // "SB, FD, RD & Deposit Schemes",
        "Savings, Fixed, Recurring & Dynamic Deposit Schemes",
        "Gold, Agriculture, Business & Personal Loans",
        "Automated Daybook & General Ledger",
        "Complete Audit Trails",
        "Dividend & Bonus Disbursement"
      ]
    },
    {
      title: "Compliance & Governance",
      image: complianceImg,
      points: [
        "By-Law Configuration",
        "AGM Notice & Resolution Tracking",
        "NABARD & RBI Reporting",
        "State and multi State Cooperative Compliance",
        "Internal Audit Module"
      ]
    },
    {
      title: "Digital Services",
      image: digitalImg,
      points: [
        "Mobile Banking for Members",
        "SMS Alerts & Notifications",
        "Online Member Portal",
        "Loan Applications Online",
        "Document Access & Statements"
      ]
    },
    {
      title: "Specialized Features",
      image: reportImg,
      points: [
        "Agricultural Loan Tracking",
        "Society Elections Module",
        "Multi-Level Hierarchy",
        //"Government Scheme Management"
        "Loan receiver Management"
      ]
    }
  ];

  return (
    <>
      {/* HERO SECTION */}
      <div
        className="bg-container-mscs"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="mscs-wrapper">
        <div className="mscs-left">
          <h1>IGNOSI - COOP</h1>
          <h2>Member-First Banking, Digitally Transformed</h2>
          <h3>Automate membership management with voting power tracking.</h3>

          <p>
            Automate membership management with voting power tracking, KYC compliance and seamless deposit & loan operations — all inside one unified cooperative banking platform. Experience IGNOSI Cooperative Banking Software built exclusively for member-driven institutions.
          </p>

          <ul>
            <li>Membership & Governance Automation</li>
            <li>Unified Banking Operations</li>
            <li>Regulatory Compliance Ready</li>
            <li>Digital Member Services</li>
          </ul>
        </div>

        <div className="mscs-right">
          <form className="demo-form-mscs" onSubmit={handleSubmit}>
            <input
              name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              name="organization"
              placeholder="Bank / Society Name"
              value={formData.organization}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-mscs"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {message && <p className="form-msg-mscs">{message}</p>}
          </form>
        </div>
      </div>

      {/* PLATFORM INTRO */}
      <div className="mscs-intro-section">
        <h2>Complete Banking + Cooperative Governance</h2>
        <p>Member-First Banking, Digitally Transformed with IGNOSI.</p>
      </div>

      {/* FEATURE SECTIONS */}
      <div className="mscs-features-section">
        {sections.map((sec, index) => (
          <div
            key={index}
            className={`mscs-feature-row ${index % 2 !== 0 ? "feature-reverse" : ""}`}
          >
            <div className="mscs-feature-img">
              <img src={sec.image} alt={sec.title} />
            </div>

            <div className="mscs-feature-content">
              <h3>{sec.title}</h3>
              <ul>
                {sec.points.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* WHY IGNOSI SECTION */}
      <div className="mscs-why-section">
        <h2 className="why-title-mscs">Why IGNOSI for Cooperatives?</h2>
        <div className="why-grid-mscs">
          {[
            { icon: "🏛️", title: "Structure", desc: "Built for Cooperative Structure" },
            { icon: "🤝", title: "Member-First", desc: "Member-First Approach" },
            { icon: "📈", title: "Scalable", desc: "Scalable Small to Large" },
            { icon: "✅", title: "Compliance", desc: "Compliance Assured" },
            { icon: "☁️", title: "Digital", desc: "Digital Transformation" }
          ].map((item, idx) => (
            <div key={idx} className="why-card-mscs">
              <div className="why-icon-mscs">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default MscsPage;